import { render, staticRenderFns } from "./LabelLayoutItem.vue?vue&type=template&id=870fc350&"
import script from "./LabelLayoutItem.vue?vue&type=script&lang=js&"
export * from "./LabelLayoutItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelLayoutItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports